<script lang="ts">
    import {apdate,aptime,apmonth} from 'journalize';
    import {latestUpdate, latestTrendsUpdate, trendsHaveResults} from '../utils/race-helpers'

    export let page;
    /** A readable Svelte store of this page's races (import('../types.d').ScopeFeed) */
    export let feed;
    export let trends: any = undefined; // national only

    $: latestUpdateTime = trends ? latestTrendsUpdate($trends) : latestUpdate($feed);

    $: time = aptime(latestUpdateTime)
    $: month = apmonth(latestUpdateTime)
    $: day = latestUpdateTime.getDate()

    // $:final = `${date} ${time}`

    $: hasResults = trends
        ? trendsHaveResults($trends)
        : $feed.some((race: import('../types.d').Race) => race.attributes.totalVotes > 0);

</script>
<div class="pending-results-modal">
    <p class="pending-results-header">
        Note to readers
    </p>
    
    {#if hasResults} 
        <p class="prose">This page is current as of {time} on {month} {day} and will be updated as results come in from {#if (page == 'key-races' || page == 'ca' || page == 'lacity' || page == 'national')}the Associated Press{:else}Los Angeles County{/if}.</p>
    {/if}

    <p class="prose">Winners may not be known on election night as officials count mail-in ballots, which must be postmarked by Nov. 3. Results will be certified in early December.</p>

</div> 
